import { CodesFileModel } from "./codes-file.model"

export class EstimateModel {
    estimate_sequence: number
    pet_no: number
    estimate_name: string
    date_added: string
    _total_charge: number
    //private _total_charge: number
    set total_charge(value: number) {
        this._total_charge = value;
    }
    get total_charge(): number {
        if (this.items_by_category && this.items_by_category.length > 0) {
            this._total_charge = 0
            this.items_by_category.forEach(element => {
                if (element.procs && element.procs.length > 0) {
                    element.procs.forEach(proc => {
                        this._total_charge += Number(proc.price);
                    });
                }
            });
        }
        return this._total_charge;
    }
    estimate_note: string
    items_by_category: ItemByCategoryModel[]
    estimate_def: EstimateDefModel[]

    constructor(
        estimate_sequence: number,
        pet_no: number,
        estimate_name: string,
        date_added: string,
        total_charge: number,
        estimate_note: string,
        items_by_category: ItemByCategoryModel[]
    ) {
        this.estimate_sequence = estimate_sequence
        this.pet_no = pet_no
        this.estimate_name = estimate_name
        this.date_added = date_added
        this.total_charge = total_charge
        this.estimate_note = estimate_note
        this.items_by_category = items_by_category
        this.estimate_def = []
    }
}

export class EstimateDefModel {
    estimate_def_sequence: number
    dept_estimate_sequence: number
    link_no: number
    link_type: number
    link_count: number
    link_cost: number
    defined: boolean
    status: string
    code_name: string
    procedure_desc: string
    code_category: string
    type: string

    constructor(
        estimate_def_sequence: number,
        dept_estimate_sequence: number,
        link_no: number,
        link_type: number,
        link_count: number,
        link_cost: number,
        defined: boolean,
        status: string,
        code_name: string,
        procedure_desc: string,
        code_category: string,
        type: string,
    ) {
        this.estimate_def_sequence = estimate_def_sequence
        this.dept_estimate_sequence = dept_estimate_sequence
        this.link_no = link_no
        this.link_type = link_type
        this.link_count = link_count
        this.link_cost = link_cost
        this.defined = defined
        this.status = status;
        this.code_name = code_name;
        this.procedure_desc = procedure_desc;
        this.code_category = code_category;
        this.type = type;
    }
}

export class AddCodesFileModel extends CodesFileModel {
    sequence: number
    quantity: string
    price: string
    estimate_def_sequence: number
    defined: boolean

    constructor(
        code_no: number,
        code_name: string,
        code_category: string,
        quantity: string,
        price: string,
        estimate_def_sequence: number,
        defined: boolean,
    ) {
        super(0, 0, code_no, 0, code_name, '', 0, '', '', '', code_category, '', '', 0, '', '');
        this.quantity = quantity
        this.price = price
        this.estimate_def_sequence = estimate_def_sequence
        this.defined = defined
    }
}

export class ItemByCategoryModel {
    procs: AddCodesFileModel[]
    category_name: string
    category_no: number
    category_code: string
    quantity: number
    price: number
    private _total_charge: number
    set total_charge(value: number) {
        this._total_charge = value;
    }
    get total_charge(): number {
        if (this.procs && this.procs.length > 0) {
            this._total_charge = 0
            this.procs.forEach(element => {
                this._total_charge += Number(element.price);
            });
        }
        return this._total_charge;
    }

    constructor(
        procs: AddCodesFileModel[],
        category_name: string,
        category_no: number,
        category_code: string,
        quantity: number,
        price: number
    ) {
        this.procs = procs
        this.category_name = category_name
        this.category_no = category_no
        this.category_code = category_code
        this.quantity = quantity
        this.price = price
    }
}